<template>
  <v-container fluid grid-list-md>
    <v-subheader>ブックマークユーザー一覧</v-subheader>
    <v-layout row wrap>
      <v-flex v-for="user in users" :key="user.user_id" xs12 md4>
        <v-card :href="'https://alis.to/users/' + user.user_id">
          <v-card-actions class="py-0">
            <v-avatar>
              <img v-if="user.icon_image_url" :src="user.icon_image_url" />
              <v-icon v-else large v-text="'account_circle'" />
            </v-avatar>
            <div>
              <div v-text="user.user_display_name" />
            </div>
          </v-card-actions>
          <v-card-text class="caption" v-text="user.self_introduction" />
        </v-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
  export default {
    props: {
      users: {
        type: Array
      }
    }
  }
</script>


// WEBPACK FOOTER //
// src/components/bookmark/Users.vue